import { Document, Page, View, StyleSheet, Text, Image, Font, PDFViewer} from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import imgttde from '../../../assets/images/ttde.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import srcRobotoBoldItalic from '../../../assets/custom/font/roboto/Roboto-BoldItalic.ttf'
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf'
import { formatDateStringLocalDateINA, formatDateStringLocalDateUS } from "../../../utilities/Utils";
import imgGaruda from '../../../assets/images/pngwing.png';

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })
Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })
Font.register({ family: 'Roboto-BoldItalic', src: srcRobotoBoldItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 65,
        height: 65,
        marginVertical: 15,
        marginHorizontal: 190,
    },
    headingTtd: {
        width: 200,
        height: 60,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 11,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 11,
        fontFamily: "Arial-Bold"
    },
    textIn: {
        fontSize: 11,
        fontFamily: "Roboto-Italic"
    },
    textInBold: {
        fontSize: 11,
        fontFamily: "Roboto-BoldItalic"
    },
    background: {
        position: 'absolute',
        top: '20%',
        left: '6%',
        width: 520,
        opacity: 0.2,
    },
})

const SertCBIB = () => {

    // let kapalService = useMemo(() => new KapalService(), [])
    // const [dataInspeksi, setDataInspeksi] = useState(null)
    // const [dataSert, setDataSert] = useState(null)
    // const [isUnder5GT, setIsUnder5GT] = useState(null)
    // const [dataSertProduk, setDataSertProduk] = useState(null)

    // const fetchAllData = useCallback(async () => {
    //     if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
    //         console.log("data Kapal atau data disposisi kosong")
    //         return
    //     }

    //     try {
    //         setIsUnder5GT(dataPpmKapal.ukuranKapal <= 5 ? 'Y' : 'T')

    //         const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
    //         if (resDataInspeksi) {
    //             const idInspeksi = resDataInspeksi.data.idInspeksi
    //             setDataInspeksi(resDataInspeksi.data)

    //             const results = await Promise.allSettled([
    //                 kapalService.listApprovalTeknis(idInspeksi)
    //             ])

    //             const [resApproval] = results

    //             const dataApproval = resApproval.value?.data?.data[0]

    //             const resSert = await kapalService.listKapalSertifikat(dataPpmKapal.nomorAjuKapal, dataApproval.nomorSertifikat, dataPpmKapal.namaKapal)

    //             setDataSert(resSert.data.data[0])

    //             const resSertProduk = await kapalService.listKapalSertifikatProduk(resSert.data.data[0].idSert, dataPpmKapal.nomorAjuKapal)
    //             setDataSertProduk(resSertProduk.data.data)
    //         }
    //     } catch (error) {

    //     }
    // }, [dataDisposisi, dataPpmKapal, kapalService])

    // useEffect(() => {
    //     let isMounted = true;
    //     if (!dataPpmKapal) return;

    //     const loadData = async () => {
    //         try {
    //             await fetchAllData();
    //         } catch (e) {
    //             if (isMounted) console.error(e);
    //         }
    //     };

    //     loadData();

    //     return () => { isMounted = false; };
    // }, [dataPpmKapal, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Image
                    src={imgKkp}
                    style={[styles.background ]}
                    fixed
                />

                <View style={[styles.table, { alignItems: 'center' }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { justifyContent: 'center' }]}>
                            <Image style={[styles.headingImg]} src={imgGaruda} />
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 10, textAlign: 'center' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.textBold, { fontSize: 10, textDecoration: 'underline', textAlign: 'center' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.textInBold, { textAlign: 'center' }]}>Ministry of Marine Affairs and Fisheries</Text>
                            <Text style={[styles.textInBold, { textAlign: 'center' }]}>Marine and Fisheries Quality Assurance Agency</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 10, textDecoration: 'underline', textAlign: 'center' }]}>SERTIFIKAT CARA BUDIDAYA IKAN YANG BAIK</Text>
                            <Text style={[styles.textInBold, { textAlign: 'center' }]}>CERTIFICATE OF GOOD AQUACULTURE PRACTICES</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 11, textAlign: 'center' }]}>Nomor: </Text>
                        </View>
                    </View>
                </View>
                
                <View style={[styles.table, { paddingBottom: 5, marginTop: 10 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center', textDecoration: 'underline' }]}>Diberikan Kepada</Text>
                            <Text style={[styles.textIn, { textAlign: 'center' }]}>This is to certify that</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingBottom: 5 }]}>
                    <View style={[styles.tableRow, { paddingLeft: 25, paddingRight: 15}]}>
                        <View style={[styles.tableRow, { marginTop: 10 }]}>
                            <View style={[styles.tableCol, { width: '40%',  }]}>
                                <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Unit Usaha Budidaya Ikan</Text>
                                <Text style={[styles.textIn, { textAlign: 'left' }]}>The Aquaculture Enterprise</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '3%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '57%' }]}>
                                <Text style={[styles.textBold, { fontSize: 10, textAlign: 'left' }]}>NAMA Buidaya</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { marginTop: 10 }]}>
                            <View style={[styles.tableCol, { width: '40%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Nomor Induk Berusaha</Text>
                                <Text style={[styles.textIn, { textAlign: 'left' }]}>Business Identification Number</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '3%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '57%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>NIB</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { marginTop: 10 }]}>
                            <View style={[styles.tableCol, { width: '40%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Alamat</Text>
                                <Text style={[styles.textIn, { textAlign: 'left' }]}>Address</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '3%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '57%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}> Alamat</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { marginTop: 10 }]}>                    
                            <View style={[styles.tableCol, { width: '40%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Jenis Produk</Text>
                                <Text style={[styles.textIn, { textAlign: 'left' }]}>Commodity</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '3%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '57%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>
                                    Ikan Lele
                                </Text>
                                <Text style={[styles.textIn, { fontSize: 10, textAlign: 'left' }]}>
                                    Catfish
                                </Text>
                            </View>
                        </View>
                        
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 10, paddingBottom: 5 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center', textDecoration: 'underline' }]}>Telah memenuhi persyaratan Cara Budidaya Ikan yang Baik dengan nilai</Text>
                            <Text style={[styles.textIn, { textAlign: 'center' }]}>Has fulfilled the Good Aquaculture Practices requirements with grade</Text>
                        </View>
                    </View>
                </View>
                 <View style={[styles.table, { paddingTop: 5, paddingBottom: 5 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.textBold, { fontSize: 10, textAlign: 'center', textDecoration: 'underline' }]}>SANGAT BAIK</Text>
                            <Text style={[styles.textInBold, { fontSize: 10, textAlign: 'center' }]}>EXCELLENT</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableRow, { width: '17%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Diterbitkan di</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Issued in</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '17%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Pada tanggal</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Date</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}></Text>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                   
                    <View style={[styles.tableRow, { marginBottom: 3, marginTop: 30 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableRow, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Kepala BPPMHKP</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Director General of MFQAA</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '10%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', alignItems: 'center' }]}>
                            <Image style={[styles.headingTtd]} src={imgttde} />
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Ishartini</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '10%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>

                    <View style={[styles.table, { paddingTop: 20, paddingBottom: 5 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center', textDecoration: 'underline' }]}>Sertifikat ini berlaku selama 4 (empat) tahun sejak tanggal dikeluarkan</Text>
                            <Text style={[styles.textIn, { textAlign: 'center' }]}>The Certificate is valid for 4 (four) years after issue date</Text>
                        </View>
                    </View>
                </View>
                </View>
            </Page>
        </Document>
    )
}

// const SertCBIBView = () => (

//     <PDFViewer width="100%" height={800}>
//         <SertCBIB />
//     </PDFViewer>
// );
export default SertCBIB;